import {useEffect, useState} from "react";
import {WS_BASE} from "../api";
import {useAuth} from "../auth";
import type {Payment} from "../types";

export function usePaymentsSocket() {
    const auth = useAuth();
    const [payments, setPayments] = useState<Payment[]>([]);

    useEffect(() => {
        if (!auth.user?.sub || !auth.token) {
            setPayments([]);
            return;
        }

        const ws = new WebSocket(`${WS_BASE}/payment-out/new/${auth.user.sub}`, [auth.token]);

        ws.onmessage = (event) => {
            const data = JSON.parse(event.data) as Payment | Payment[];
            if (Array.isArray(data)) {
                setPayments(data);
            } else {
                setPayments((prev) => [data, ...prev]);
            }
        };

        ws.onclose = () => {
            console.log("WebSocket closed");
        };

        return () => {
            ws.close();
        };
    }, [auth.user?.sub, auth.token]);

    return payments;
}
